import { render, staticRenderFns } from "./ItemGridItem.vue?vue&type=template&id=3a75dd09"
import script from "./ItemGridItem.vue?vue&type=script&lang=js"
export * from "./ItemGridItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports